import { render, staticRenderFns } from "./BrightHR.vue?vue&type=template&id=7306d0d4&scoped=true&"
import script from "./BrightHR.vue?vue&type=script&lang=js&"
export * from "./BrightHR.vue?vue&type=script&lang=js&"
import style0 from "./BrightHR.vue?vue&type=style&index=0&id=7306d0d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7306d0d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
